import { RatingCategory } from "@sona/shared-model-common";

export const ratingColors = {
    [RatingCategory.VERY_GOOD]: '#00ad00',
    [RatingCategory.GOOD]: '#00ad00',
    [RatingCategory.SATISFYING]: '#eb7100',
    [RatingCategory.SUFFICIENT]: '#eb7100',
    [RatingCategory.FAILED]: '#e00000',
    [RatingCategory.COMPLETELY_FAILED]: '#e00000'
};

export const ratingColorsDark = {
    [RatingCategory.VERY_GOOD]: '#15803d',
    [RatingCategory.GOOD]: '#15803d',
    [RatingCategory.SATISFYING]: '#b45309',
    [RatingCategory.SUFFICIENT]: '#b45309',
    [RatingCategory.FAILED]: '#b91c1c',
    [RatingCategory.COMPLETELY_FAILED]: '#b91c1c'
};
